import $ from 'jquery';

$(document).ready(function () {
  // calendar

  function removeCellsCalendar() {
    let cellTablesEmpty = $('.cCalendarItem.not_cells');
    if (cellTablesEmpty.length >= 7) {
      cellTablesEmpty.slice(-7).remove();
    }
  }
  $("#sectCalendar").on("click", ".cCalendarItem", function () {
    var day = $(this).children("span").attr("data-day");
    var date = $(this).children("span").attr("data-date");
    let date_sub = $(this).hasClass('date-sub');
    let data_next = $(this).hasClass('not_cells');
    if (date_sub !== true && data_next !== true) {
      if (day === undefined) {
        day = null;
      }
      $.ajax({
        url: '/event/ajax/calendar_top',
        data: {
          'day': day,
          'date': date
        },
        success: function (response) {
          if (response.status == 200) {
            $("#sectCalendarCol").html(response.data);
          }
        },
      });
    } else if (date_sub) {
      let month = $('#cCalendarPrev').data('month').split('-');
      if ($(this).data('date-index') !== '') {
        let number_day = $(this).index() + 1 - $('.date-sub').length;
        let days = new Date(month[0], month[1], 0).getDate();
        $.ajax({
          url: '/event/ajax/calendar_top',
          data: {
            'day': days + number_day,
            'date': $('#cCalendarPrev').data('month'),
          },
          success: function (response) {
            if (response.status == 200) {
              response = $(response.data).filter('.sectCalendarHead');
              $("#sectCalendarCol").html(response);
            }
          },
        });
      }
    } else if (data_next) {
      let number_day = $(this).data('date');
      $.ajax({
        url: '/event/ajax/calendar_top',
        data: {
          'day': number_day,
          'date': $('#cCalendarNext').data('month'),
        },
        success: function (response) {
          if (response.status == 200) {
            response = $(response.data).filter('.sectCalendarHead');
            $("#sectCalendarCol").html(response);
          }
        },
      });

    }
  });
  $("#sectCalendar").on("click", "#cCalendarPrev", function () {
    var date = $(this).attr("data-month");
    $.ajax({
      url: '/event/ajax/render_month',
      data: {
        'date': date
      },
      success: function (response) {
        if (response.status == 200) {
          $("#sectCalendar").html(response.data);
          removeCellsCalendar();
        }
      },
    });
  });
  $("#sectCalendar").on("click", "#cCalendarNext", function () {
    var date = $(this).attr("data-month");
    $.ajax({
      url: '/event/ajax/render_month',
      data: {
        'date': date
      },
      success: function (response) {
        if (response.status == 200) {
          $("#sectCalendar").html(response.data);
          removeCellsCalendar();
        }
      },
    });
  });
  removeCellsCalendar();
  $("#news_top li:nth-child(1)").on("click", function () {
    $("#news_top").children().removeClass("active");
    $(this).addClass("active");
    getNewsList();
  });
  $("#news_top li:nth-child(2)").on("click", function () {
    $("#news_top").children().removeClass("active");
    $(this).addClass("active");
    getNewsList(1);
  });
  $("#news_top li:nth-child(3)").on("click", function () {
    $("#news_top").children().removeClass("active");
    $(this).addClass("active");
    getNewsList(2);
  });
  $("#news_top li:nth-child(4)").on("click", function () {
    $("#news_top").children().removeClass("active");
    $(this).addClass("active");
    getNewsList(3);
  });

  function getNewsList(cate = null) {
    $.ajax({
      url: '/ajax/news_list',
      data: {
        'category': cate
      },
      success: function (response) {
        if (response.status == 200) {
          $("#listNews_top").html(response.data);
        }
      },
    });
  }
  $("#see-more-available").click(function () {
    $.ajax({
      url: '/guide/ajax/more_avaiable',
      data: {
        'check': true
      },
      success: function (response) {
        if (response.status == 200) {
          $("#available-schedule").html(response.data);
        }
      },
    });
  });
  const formContact = {
    init: function () {
      this.contactForm();
      this.scroll();
      this.sendmail();
      this.back();
      this.backContactThanks();

    },
    contactForm: function () {
      var radioNo = document.getElementById('no');
      var radioYes = document.getElementById('yes');

      if (radioNo && radioYes) {
        let txt = document.querySelectorAll('.txt_input');
        let txtInfo = document.querySelectorAll('.txtdisabled');
        if (radioNo.checked == true) {
          for (let i = 0; i < txt.length; i++) {
            txt[i].setAttribute('disabled', 'disabled');
            txt[i].style.cssText = `
        background-color: rgb(221, 221, 221);
        `;
            txtInfo[i].style.cssText = "display:none";
          }
        }
        radioNo.onchange = function () {

          for (let i = 0; i < txt.length; i++) {
            txt[i].setAttribute('disabled', 'disabled');
            txt[i].style.cssText = `
    background-color: rgb(221, 221, 221);
    `;
            txt[i].value = "";
            txtInfo[i].style.cssText = "display:none";
          }
        }
        radioYes.onchange = function () {

          for (let i = 0; i < txt.length; i++) {
            txt[i].removeAttribute('disabled');
            txt[i].style.cssText = ``;
            txtInfo[i].style.cssText = "display:block";
          }
        }
      }
    },
    scroll: function () {
      function onScrollToResult(div) {
        let blockResult = document.getElementById(div),
          hHeader;
        if (window.innerWidth < 769) {
          if (document.querySelector("#header")) {
            hHeader = document.querySelector("#header").clientHeight;
          }

        } else {
          if (document.querySelector(".hNav ")) {
            hHeader = document.querySelector(".hNav ").clientHeight;
          }

        }
        if (blockResult) {
          let posResult = blockResult.offsetTop;
          window.scrollTo({
            top: posResult - hHeader,
            behavior: 'smooth'
          });
        }
      }

      function onScrollToTop(resetFunc) {
        if (resetFunc) {
          window.removeEventListener('scroll', resetFunc);
          var scrollToTop = window.setInterval(function () {
            var pos = window.pageYOffset;
            if (pos > 0) {
              window.scrollTo(0, pos - 20);
            } else {
              window.clearInterval(scrollToTop);
            }
          }, 16);
        }
      }

      onScrollToTop(onScrollToResult('myFocusField'));
    },
    sendmail: function() {
      let btnSendmail = document.querySelector('.btnSendmail');
      if (btnSendmail) {
          btnSendmail.onclick = function() {
              let formSendmail = document.querySelector('.formSendmail');
              if (formSendmail) {
                  formSendmail.submit();
              }
              btnSendmail.setAttribute('disabled',true);
          };
      }
    },
    back: function () {
      let back = document.querySelector('.btnBack');
      var formBack = document.querySelector('#form-back');
      if (back) {
        back.onclick = function () {
          if (formBack) {
            formBack.submit();
          }
        }
      }
    },
    backContactThanks: function () {

      let contactThanks = document.querySelector('#contactThanks');
      if (localStorage.getItem('contactThanks')) {
        if (window.location.pathname == '/contact') {
          localStorage.removeItem('contactThanks');
          window.location = "/contact";
        }
        localStorage.removeItem('contactThanks');
      }
      if (contactThanks) {
        localStorage.setItem('contactThanks', true);
      }
    }


  }
  const search = {
    int: function () {
      this.activeForm();
      this.searchForm();
    },
    activeForm: function () {
      var ttl = document.querySelector('#showSearchBox');
      var groupFilter = document.querySelector('.groupFilter');

      if (ttl) {
        ttl.addEventListener('click', function () {
          ttl.classList.toggle('active');
          groupFilter.classList.toggle('active');
        })
      }
    },
    searchForm: function () {
      var start_year = document.querySelector('#start_year');
      var start_month = document.querySelector('#start_month');
      var start_day = document.querySelector('#start_day');


      var end_year = document.querySelector('#end_year');
      var end_month = document.querySelector('#end_month');
      var end_day = document.querySelector('#end_day');
      if (start_day || start_month || start_day) {
        day(start_year, start_month, start_day, 'start_day');
      }
      if (end_year || end_month || end_day) {
        day(end_year, end_month, end_day, 'end_day');
      }

      function day(year, month, day, type) {
        let y = year.value;
        let m = month.value;
        let d = new Date(y, m, 0).getDate();
        let html = `<option value="">日</option>`;
        let day_type;

        let link = window.location.search;

        let search = link.split("&");
        if (link) {
          search.forEach(element => {
            if (element.includes(type)) {
              day_type = element.split("=")[1];
            }
          });
        } else if (type == "start_day") {
          const birthday = new Date();
          day_type = birthday.getDate();
        }

        if (type == "start_day" || link) {
          for (let i = 1; i <= d; i++) {
            if (i == day_type && day_type) {
              html += `<option selected value="${i}">${i}</option>`;
            } else {
              html += `<option  value="${i}">${i}</option>`;
            }
          }
        }
        day.innerHTML = html;
        year.onchange = function () {
          let y = year.value;
          let m = month.value;
          let d = new Date(y, m, 0).getDate();
          let html = `<option value="" selected="selected">日</option>`;

          for (let i = 1; i <= d; i++) {
            html += `<option  value="${i}">${i}</option>`;
          }
          day.innerHTML = html;
        }
        month.onchange = function () {
          let m = month.value;
          var y = year.value;
          let d = new Date(y, m, 0).getDate();
          let html = `<option value="" selected="selected">日</option>`;
          for (let i = 1; i <= d; i++) {
            html += `<option  value="${i}">${i}</option>`;

          }
          day.innerHTML = html;
        }
      };
    }

  }
  const scrollEfforts = {
    init: function () {
      this.scroll();
      this.scrollWindow();
    },
    scroll: function () {
      var block = document.querySelectorAll("#block");
      if (block) {
        block.forEach((v, k) => {
          block[k].onclick = function () {
            scrollTab(block[k].getAttribute('data-href'))
          }
        })
      }

      function scrollTab(anchorLink) {
        var heightNav = document.querySelector('#tagListBlock').clientHeight;
        console.log(heightNav);
        if (document.querySelector(anchorLink)) {
          var offTop = document.querySelector(anchorLink).offsetTop - heightNav;
          window.scrollTo({
            top: offTop,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    },
    scrollWindow: function () {
      window.onscroll = function () {
        let pageToTop = document.querySelector(".effort .pageToTop");
        if (pageToTop) {
          if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0 && (document.documentElement.scrollTop + window.innerHeight) < document.querySelector(".effort").offsetTop) {
            pageToTop.classList.add('show');
          } else {
            pageToTop.classList.remove('show');
          }
        }
      }
    }
  }
  scrollEfforts.init();
  formContact.init();
  search.int();
})
